import {toast} from "react-toastify";
import {collection, doc, onSnapshot, query, updateDoc, where} from "firebase/firestore";
import {auth, db} from "../config/firebase";
import axios from "axios";
import {LicenseRequestType} from "./enums/LicenseRequestType";

let unsubscribeOwnedListener = null;
let unsubscribeReceivedListener = null;
let unsubscribeLicensedTemplatesListener = null; // Listener for the templates user has licenses for

let latestOwnedTemplates = [];
let latestReceivedLicenseInfo = []; // Stores info from user_received_licenses
let latestLicensedTemplates = []; // Stores the actual royalty_template docs for received licenses


export const copyToClipboard = (data) => {
    try {
        navigator.clipboard.writeText(data);
        toast.success("Successfully copied to clipboard")
    } catch (error) {
        toast.error("Error copying URL")
    }
}

export async function loadNFts(dispatch, royaltyTemplates) {
    if (royaltyTemplates.length > 0) return
    try {
        const userCollectionsCollection = collection(db, "royalty_templates");
        const customQuery = query(userCollectionsCollection, where("userUid", "==", auth.currentUser.uid))
        // const querySnapshot = await getDocs(customQuery);
        // const nftWorks = []
        // querySnapshot.forEach((doc) => {
        //     nftWorks.push(doc.data());
        // })
        onSnapshot(customQuery, (querySnapshot) => {
            let newData = [];
            querySnapshot.forEach(doc => {
                const data = doc.data();
                newData.push(data);
            });
            for (const template of royaltyTemplates) {
                const index = newData?.findIndex(i => i?.uid === template?.uid);
                if (index < 0) {
                    newData.push(template);
                }
            }
            newData = newData.sort((a, b) => b.createdAt - a.createdAt);
            dispatch({type: "update_royalty_templates", payload: [...royaltyTemplates, ...newData]});
        });
    } catch (error) {
        toast.error("Error loading your works, please refresh!")
        console.error('Error:', error);
    }
}

export function loadPortfolioItems(dispatch, userUid) {

    const dispatchCombinedTemplates = () => {
        console.log("--- dispatchCombinedTemplates ---");
        const combinedMap = new Map();

        // 1. Add owned templates
        console.log(`Processing ${latestOwnedTemplates.length} owned templates...`);
        latestOwnedTemplates.forEach(item => {
            if (item.uid) {
                console.log(`  Adding owned template: ${item.uid}`);
                combinedMap.set(item.uid, { ...item, itemType: 'created' });
            } else {
                console.warn("  Owned template missing uid:", item);
            }
        });

        // 2. Process licensed templates
        console.log(`Processing ${latestLicensedTemplates.length} licensed templates...`);
        latestLicensedTemplates.forEach(template => {
            // Only add if not already present as an owned template
            if (template.uid && !combinedMap.has(template.uid)) {
                console.log(`  Processing licensed template: ${template.uid}`);
                // Find all ACTIVE received license records for THIS template UID
                const relevantLicenseInfos = latestReceivedLicenseInfo.filter(
                    licInfo => licInfo.originalNftUid === template.uid && !licInfo.archived
                );
                console.log(`    Found ${relevantLicenseInfos.length} active license info records for this template.`);

                // Get the UIDs of the specific license TEMPLATES the user holds for this work
                const heldLicenseTemplateUids = relevantLicenseInfos.map(licInfo => licInfo.licenseUid);
                console.log(`    Held license template UIDs: [${heldLicenseTemplateUids.join(', ')}]`);

                if (heldLicenseTemplateUids.length > 0) {
                    const originalLicenses = template.licenses || [];
                    console.log(`    Original template licenses array length: ${originalLicenses.length}`);
                    // Filter the template's internal licenses array
                    const filteredLicenses = originalLicenses.filter(
                        licenseTemplate => {
                            const included = heldLicenseTemplateUids.includes(licenseTemplate.uid);
                            // console.log(`      Checking license template UID ${licenseTemplate.uid}: Included = ${included}`); // Verbose log if needed
                            return included;
                        }
                    );
                    console.log(`    Filtered licenses array length: ${filteredLicenses.length}`);

                    // Create the object for the map
                    const licensedItemData = {
                        ...template, // Spread original template
                        licenses: filteredLicenses, // Assign the filtered array
                        itemType: 'licensed'
                    };
                    console.log(`    Adding licensed template ${template.uid} to map with ${filteredLicenses.length} licenses.`);
                    combinedMap.set(template.uid, licensedItemData);

                    if (filteredLicenses.length === 0) {
                        console.warn(`    Template ${template.uid} added as licensed, but its internal 'licenses' array didn't contain matching UIDs for held licenses: ${heldLicenseTemplateUids.join(', ')}. Check data consistency.`);
                    }
                } else {
                    console.log(`    Template ${template.uid} was fetched but no corresponding *active* user_received_licenses info found. Skipping.`);
                }
            } else if (template.uid && combinedMap.has(template.uid)) {
                console.log(`  Skipping licensed template ${template.uid} because it's already present as owned.`);
            } else if (!template.uid) {
                console.warn("  Licensed template missing uid:", template);
            }
        });

        const combinedArray = Array.from(combinedMap.values());
        console.log(combinedArray)

        // Sort the combined array
        const sortedCombined = combinedArray.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));

        console.log(`Dispatching ${sortedCombined.length} total portfolio templates.`);
        // Dispatch using the original action type
        dispatch({ type: "update_royalty_templates", payload: sortedCombined });
        console.log("--- dispatchCombinedTemplates END ---");
    };

    // --- Cleanup existing listeners ---
    cleanupPortfolioListener();

    if (!userUid) {
        console.log("No user UID provided, cannot load portfolio.");
        dispatch({ type: "update_royalty_templates", payload: [] });
        return;
    }

    // --- Listener 1: Owned Royalty Templates ---
    try {
        console.log(`Setting up listener for owned templates (user: ${userUid})`);
        const ownedQuery = query(collection(db, "royalty_templates"), where("userUid", "==", userUid));

        unsubscribeOwnedListener = onSnapshot(ownedQuery, (querySnapshot) => {
            console.log("Owned templates snapshot received.");
            const freshOwned = [];
            querySnapshot.forEach(doc => {
                freshOwned.push({ ...doc.data(), id: doc.id, uid: doc.data().uid || doc.id });
            });
            latestOwnedTemplates = freshOwned;
            dispatchCombinedTemplates();

        }, (error) => {
            console.error("Error in owned templates listener:", error);
            toast.error("Error listening for owned works updates.");
            latestOwnedTemplates = [];
            dispatchCombinedTemplates();
            cleanupPortfolioListener();
        });

    } catch (error) {
        toast.error("Error setting up owned works listener!")
        console.error('Error setting up owned listener:', error);
        cleanupPortfolioListener();
    }

    // --- Listener 2: Received Licenses Info (Filter for Active) ---
    try {
        console.log(`Setting up listener for active received licenses info (user: ${userUid})`);
        const receivedQuery = query(
            collection(db, "user_received_licenses"),
            where("recipientUserUid", "==", userUid),
            where("archived", "==", false) // Only get active licenses
        );

        unsubscribeReceivedListener = onSnapshot(receivedQuery, async (querySnapshot) => {
            console.log("Active received licenses info snapshot received.");
            const activeReceivedLicenseInfos = [];
            querySnapshot.forEach(doc => {
                activeReceivedLicenseInfos.push({ ...doc.data(), id: doc.id });
            });
            latestReceivedLicenseInfo = activeReceivedLicenseInfos;

            // --- Fetch Corresponding Royalty Templates for Active Licenses ---
            const activeLicensedTemplateUids = latestReceivedLicenseInfo
                .map(lic => lic.originalNftUid)
                .filter((uid, index, self) => uid && self.indexOf(uid) === index);

            if (unsubscribeLicensedTemplatesListener) {
                console.log("Cleaning up previous licensed templates listener.");
                unsubscribeLicensedTemplatesListener();
                unsubscribeLicensedTemplatesListener = null;
                latestLicensedTemplates = [];
            }

            if (activeLicensedTemplateUids.length > 0) {
                console.log(`Found ${activeLicensedTemplateUids.length} active licensed template UIDs. Setting up listener...`);
                if (activeLicensedTemplateUids.length > 30) {
                    console.warn("User has more than 30 active received licenses. Portfolio display might be incomplete due to query limits.");
                }
                const licensedTemplatesQuery = query(collection(db, "royalty_templates"), where("uid", "in", activeLicensedTemplateUids.slice(0, 30)));

                unsubscribeLicensedTemplatesListener = onSnapshot(licensedTemplatesQuery, (templateSnapshot) => {
                    console.log("Active licensed templates snapshot received.");
                    const freshLicensed = [];
                    templateSnapshot.forEach(doc => {
                        freshLicensed.push({ ...doc.data(), id: doc.id, uid: doc.data().uid || doc.id });
                    });
                    latestLicensedTemplates = freshLicensed;
                    dispatchCombinedTemplates();
                }, (error) => {
                    console.error("Error in active licensed templates listener:", error);
                    toast.error("Error listening for licensed works updates.");
                    latestLicensedTemplates = [];
                    dispatchCombinedTemplates();
                    if (unsubscribeLicensedTemplatesListener) unsubscribeLicensedTemplatesListener();
                    unsubscribeLicensedTemplatesListener = null;
                });

            } else {
                console.log("User has no active received licenses with valid originalNftUid.");
                latestLicensedTemplates = [];
                dispatchCombinedTemplates();
            }

        }, (error) => {
            console.error("Error in active received licenses info listener:", error);
            toast.error("Error listening for received licenses updates.");
            latestReceivedLicenseInfo = [];
            latestLicensedTemplates = [];
            dispatchCombinedTemplates();
            cleanupPortfolioListener();
        });

    } catch (error) {
        toast.error("Error setting up received licenses listener!")
        console.error('Error setting up received listener:', error);
        cleanupPortfolioListener();
    }
}

// Updated cleanup function
export function cleanupPortfolioListener() {
    if (unsubscribeOwnedListener) {
        console.log("Cleaning up owned templates listener.");
        unsubscribeOwnedListener();
        unsubscribeOwnedListener = null;
    }
    if (unsubscribeReceivedListener) {
        console.log("Cleaning up received licenses info listener.");
        unsubscribeReceivedListener();
        unsubscribeReceivedListener = null;
    }
    if (unsubscribeLicensedTemplatesListener) {
        console.log("Cleaning up licensed templates listener.");
        unsubscribeLicensedTemplatesListener();
        unsubscribeLicensedTemplatesListener = null;
    }
    // Reset cached data
    latestOwnedTemplates = [];
    latestReceivedLicenseInfo = [];
    latestLicensedTemplates = [];
}

export async function mintNft(publicAddress, nftUid, setNftTxnHash, setStatus, nftData) {
    const url = process.env.REACT_APP_ENVIRONMENT === 'development' ?
        'http://localhost:5001/c3-nft-c3/us-central1/mintNft' :
        'https://us-central1-c3-nft-c3.cloudfunctions.net/mintNft'
    console.log(publicAddress)
    const userEmail = auth.currentUser?.email;
    console.log(userEmail)
    console.log(url)
    if (!userEmail) {
        toast.error("User email not found, cannot mint.");
        console.log("User email not found, cannot mint.")
        setStatus && setStatus('failed');
        return null;
    }

    const params = { publicAddress: publicAddress, nftUid: nftUid, userEmail: userEmail };
    try {
        console.log("Minting NFT from backend")
        console.log(url)
        console.log(params)
        const response = await axios.get(url, { params });
        console.log("Minting response:", response.data);

        if (response.data && response.data.success === true && response.data.transaction_hash) {
            setNftTxnHash && setNftTxnHash(response.data.transaction_hash);

            const nftRef = doc(db, 'royalty_templates', nftUid);
            await updateDoc(nftRef, { nftTxnHash: response.data.transaction_hash, paid: true, matTokenId: response.data.token_id });
            console.log('STATUS COMPLETE')
            setStatus && setStatus('complete');

            if (nftData) {
                console.log("NFT DATAAAAAAAAAA")
                nftData.nftTxnHash = response.data.transaction_hash;
                nftData.paid = true;
                nftData.matTokenId = response.data.token_id;
            }
            console.log("nftData")
            console.log(nftData)
            return nftData;
        } else {
            const errorMsg = response.data?.error || response.data?.message || 'Minting failed. Check transaction logs.';
            console.error("Minting failed:", errorMsg, "Backend response:", response.data);
            toast.error(errorMsg);
            setStatus && setStatus('failed');
            return null;
        }
    } catch (error) {
        console.error('Error calling mintNft endpoint:', error);
        const errorMsg = error.response?.data?.error || error.response?.data?.message || error.message || "An unexpected error occurred during minting.";
        toast.error(`Minting failed: ${errorMsg}`);
        setStatus && setStatus('failed');
        return null;
    }
}


export async function mintLicense(publicAddress, nftUid, durationInDays, licenseUid, licenseRequestUid, buyerUid, sessionId) {
    const url = process.env.REACT_APP_ENVIRONMENT === 'development' ?
        'http://localhost:5001/c3-nft-c3/us-central1/mintLicense' :
        'https://us-central1-c3-nft-c3.cloudfunctions.net/mintLicense'

    console.log("MINTING LICENSE FROM BACKEND")
    console.log(publicAddress)
    console.log(nftUid)
    console.log(durationInDays)
    console.log(licenseUid)
    console.log(licenseRequestUid)
    console.log(buyerUid)
    console.log(sessionId)

    const params = {
        publicAddress: publicAddress,
        nftUid: nftUid,
        durationInDays: durationInDays,
        licenseUid: licenseUid,
        licenseRequestUid: licenseRequestUid,
        buyerUid: buyerUid,
        sessionId: sessionId
    };
    try {
        const response = await axios.get(url, {params});
        console.log("response.data")
        console.log(response.data)
        if (response.data && response.data.success === true && response.data.transaction_hash) {
            return response.data.transaction_hash;
        } else {
            const errorMsg = response.data?.error || response.data?.message || 'License minting failed.';
            console.error("License minting failed:", errorMsg, "Backend response:", response.data);
            toast.error(errorMsg);
            return null;
        }
    } catch (error) {
        console.error('Error calling mintLicense endpoint:', error);
        const errorMsg = error.response?.data?.error || error.response?.data?.message || error.message || "An unexpected error occurred during license minting.";
        toast.error(`License minting failed: ${errorMsg}`);
        return null;
    }
}


export const getStripeSession = ({sessionId}) => {
    const url = process.env.REACT_APP_ENVIRONMENT === 'development' ?
        'http://localhost:5001/c3-nft-c3/us-central1/session_status' :
        'https://us-central1-c3-nft-c3.cloudfunctions.net/session_status'
    const params = {session_id: sessionId}
    return axios.get(url, {params})
}

export const chunkArray = (array, chunkSize) => {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
    }
    return result;
};


export const updateLicenseState = async (requestUid, state) => {
    if (!requestUid) {
        return;
    }
    const requestRef = doc(db, 'license_requests', requestUid)

    await updateDoc(requestRef, {state: state})
}